import Api from "./base/api-base";

export default class ExpenseRefineApi {

  list(id) {
    return Api.get({
      endpoint: Api.endpoint.expense_refine,
      id: id
    });
  }
}